import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Typography, Link } from "@aviary";
import { authRoutes } from "@unauthenticated/shared/data/authRoutes";
import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./NewToFullscriptSignUp.styles";

interface Props {
  userType: "practitioner" | "patient";
  customSignUpAction?: () => void;
}

const NewToFullscriptSignUp: FC<Props> = ({ userType, customSignUpAction }) => {
  const { t } = useTranslation();

  const renderLink = () => {
    if (customSignUpAction) {
      return (
        <Link
          css={styles.link}
          data-e2e="link-to-custom-signup-action"
          isUnderLined={false}
          onClick={customSignUpAction}
        >
          {t(l.signIn.CreateAccount)}
        </Link>
      );
    }
    if (userType === "practitioner") {
      return (
        <Link
          to={authRoutes.practitioner_sign_up}
          css={styles.link}
          data-e2e="create-practitioner-link"
          isUnderLined={false}
        >
          {t(l.signIn.CreateAccount)}
        </Link>
      );
    }

    if (userType === "patient") {
      return (
        <Link href={authRoutes.patient_sign_up} css={styles.link} isUnderLined={false}>
          {t(l.signIn.CreateAccount)}
        </Link>
      );
    }
  };

  return (
    <Typography isFullWidth>
      {t(l.signIn.NewToFullScript)} {""}
      {renderLink()}
    </Typography>
  );
};

export { NewToFullscriptSignUp };
